import {TextField} from '@material-ui/core';
import {ScalingButton} from '@screens/review-section3/styles';
import {VerticalLayout} from '@styles/spacing-styles';
import {themeProvider} from '@swipejobs/frontend-theme-provider';
import styled from 'styled-components';

export const PrimaryButton = styled(ScalingButton)`
  &&& {
    background-color: #1a98fc;

    &:hover {
      background-color: #1a98fc90;
    }

    &:active {
      background-color: #224870;
    }

    &:disabled {
      background-color: ${themeProvider.getColors().background.disabledBackgroundColor}
    }
  }
`;

export const PinCodeFormContainer = styled.form`
  display: flex;
  flex-direction: column;
  padding: 75px;
  border-radius: 25px;
  border: ${themeProvider.getFraming().border.small} ${() => themeProvider.getColors().modal.innerBorder};
  justify-content: space-between;
  min-height: 310px;
  margin-left: auto;
  margin-right: auto;
  width: 500px;
  box-sizing: border-box;

  ${PrimaryButton} {
    align-self: center;
  }

  @media (max-width: 600px) {
    width: unset;
    margin-left: 2px;
    margin-right: 2px;
  }

  @media (min-width: 320px) and (max-width: 375px) {
    padding: 50px;
    min-height: 260px;
  }

  @media (max-width: 320px) {
    padding: 25px 35px 35px;
    min-height: 180px;
  }
`;

export const PinCodeFormLayout = styled(VerticalLayout)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const PinCodeButtonStack = styled(VerticalLayout)`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
`;

export const PinCodeField = styled(TextField).attrs({
  FormHelperTextProps: {
    classes: {
      root: 'PinCodeFieldHelperText'
    }
  },
  InputLabelProps: {
    classes: {
      root: 'PinCodeFieldInputLabel',
      focused: 'focused'
    },
    shrink: true
  },
  InputProps: {
    classes: {
      root: 'PinCodeFieldInput'
    },
    disableUnderline: true
  }
})`
  && {
    /* todo: rewrite this form container with declarative inner spacing instead */
    margin-top: 10px;
  }

  .PinCodeFieldHelperText {
    margin-bottom: 8px;
  }

  .PinCodeFieldInput {
    border: 1px solid grey;
    border-radius: 4px;
    padding-left: 8px;
  }

  .PinCodeFieldInputLabel {
    color: ${() => themeProvider.getColors().title.defaultColor};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 130%; /* Matches with the width of the input better */

    &.focused {
      color: ${() => themeProvider.getColors().title.defaultColor};
    }
  }
`;

export const ErrorLabel = styled.span`
  color: ${() => themeProvider.getColors().text.errorTextMessage};
  font-weight: 600;
  font-size: ${() => themeProvider.getTypography().font.size.medium};
  display: block;
`;



// WEBPACK FOOTER //
// ./src/screens/review-section3/pincode-authorisation/pin-code-form-styles.tsx